"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_persist_1 = require("redux-persist");
var MapActions_1 = require("./MapActions");
var server_1 = require("../../helpers/server");
// Initial state values
var initialState = {
    users: [],
    places: [],
    isPlacesLoading: false,
    isUsersLoading: false,
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(MapActions_1.MapActions.USERS).success:
            return __assign(__assign({}, state), { users: action.payload, isUsersLoading: false });
        case (0, server_1.apiActions)(MapActions_1.MapActions.PLACES).success:
            return __assign(__assign({}, state), { places: placeLocation(action.payload), isPlacesLoading: false });
        case (0, server_1.apiActions)(MapActions_1.MapActions.USERS).fail:
            return __assign(__assign({}, state), { isUsersLoading: false });
        case (0, server_1.apiActions)(MapActions_1.MapActions.PLACES).fail:
            return __assign(__assign({}, state), { isPlacesLoading: false });
        case (0, server_1.apiActions)(MapActions_1.MapActions.USERS).request:
            return __assign(__assign({}, state), { isUsersLoading: true });
        case (0, server_1.apiActions)(MapActions_1.MapActions.PLACES).request:
            return __assign(__assign({}, state), { isPlacesLoading: true });
        /* ------------- LOGOUT  ------------------- */
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        /* ------------- END  LOGOUT  ------------------- */
        default:
            return state;
    }
});
// Places model coords are an array, but here are and object as per MapLocation.
// In order to separate the two objects that represent coordinates differently
var placeLocation = function (payload) {
    var placesMapLocation = payload.map(function (place) { return (__assign(__assign({}, place), { // Keep the parametters of map location (id, type, coordinates)
        place: place })); });
    return __spreadArray([], placesMapLocation, true);
};
